import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxGroup, ErrorList, TextInput, Typography, } from '@guildeducationinc/recess';
import { ProgramContext } from '@src/contexts/ProgramContextProvider';
import { EntityType } from '@src/types';
import { keyBy } from 'lodash';
import { useFieldOption, useLocale } from 'pe-core-frontend';
import { useContext, useEffect, useMemo, useState } from 'react';
import styles from './ProgramPurpose.module.scss';
export const ProgramPurpose = ({ clientId, fieldInfo, purpose, onChange, readOnly, errors, }) => {
    const { t } = useLocale();
    const [selections, setSelections] = useState([]);
    const [showOther, setShowOther] = useState(false);
    const [otherText, setOtherText] = useState('');
    const { benefitProgramProps } = useContext(ProgramContext);
    const [isActive, setIsActive] = useState(false);
    const [isRequired, setIsRequired] = useState(false);
    const { fetchFieldOption } = useFieldOption({
        extraData: { program: benefitProgramProps },
    });
    const [options, setOptions] = useState([]);
    const optionsByValue = useMemo(() => keyBy(options, 'value'), [options]);
    useEffect(() => {
        (async () => {
            const { fieldOption } = await fetchFieldOption({
                clientId: clientId ?? 0,
                entityType: EntityType.PROGRAM,
                fieldCode: 'purpose',
                query: '',
            });
            setIsActive(fieldOption?.isActive ?? false);
            setIsRequired(fieldOption?.isRequired ?? false);
            const options = fieldOption?.options?.map((opt) => {
                let label = opt.label;
                if (opt.value !== 'Other') {
                    label = t(opt.value, {
                        values: opt.params,
                    });
                }
                return {
                    value: opt.value,
                    label,
                };
            }) ?? [];
            options.push({ value: 'Other', label: t('Other') });
            setOptions(options);
            //update the isActive and isRequired and send it back
            if (onChange && !readOnly) {
                onChange({
                    ...purpose,
                    isActive: fieldOption?.isActive ?? false, // default to false because fieldOption is not found due to inactive.
                    isRequired: fieldOption?.isRequired ?? false, // default to false because fieldOption is not found due to inactive.
                });
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setOtherText(purpose.other || '');
        setShowOther(purpose.selections?.includes('Other') || false);
        setSelections(purpose.selections || []);
    }, [purpose]);
    const handleChange = (e) => {
        let newSelections = [...selections];
        let other = otherText;
        if (e.currentTarget.value === 'Other') {
            setShowOther(e.currentTarget.checked);
            if (!e.currentTarget.checked) {
                other = '';
                setOtherText('');
            }
        }
        if (e.currentTarget.checked && !selections.includes(e.currentTarget.value)) {
            newSelections.push(e.currentTarget.value);
        }
        else {
            newSelections = newSelections.filter(val => val !== e.currentTarget.value);
        }
        if (onChange) {
            onChange({
                selections: newSelections,
                other: other || undefined,
                isActive,
                isRequired,
            });
        }
    };
    const handleOtherChange = (e) => {
        setOtherText(e.target.value);
        if (onChange) {
            onChange({
                selections,
                other: e.target.value,
                isActive,
                isRequired,
            });
        }
    };
    return (_jsx(_Fragment, { children: isActive && (_jsxs("div", { className: styles.purpose, children: [!readOnly && (_jsxs(_Fragment, { children: [_jsx(CheckboxGroup, { name: 'progPurpose', values: options, handleSetMultiChecked: handleChange, groupLabel: t(fieldInfo.label), selectedValues: purpose.selections || [], required: isRequired, readOnly: readOnly }), showOther && (_jsx("div", { className: styles.otherInput, children: _jsx(TextInput, { type: 'text', label: t('Please specify'), value: otherText, onChange: handleOtherChange, readOnly: readOnly }) })), _jsx(ErrorList, { show: !!errors, errors: errors })] })), readOnly &&
                    purpose.selections?.map(sel => (_jsx("div", { className: styles.viewMode, children: _jsx("div", { className: styles.label, children: _jsxs(Typography, { variant: 'body1', children: [optionsByValue[sel]?.label, sel === 'Other' && ` - ${otherText}`] }) }) }, sel)))] })) }));
};
